// 努力値仕様をまとめた定数
export const MAX_STAT_EFFORT = 32;
export const MAX_TOTAL_EFFORT = 66;

export const EFFORT_SELECT_VALUES = Array.from({ length: MAX_STAT_EFFORT + 1 }, (_, index) => index);

export const normalizeEffortValue = (value: number): number => {
  if (Number.isNaN(value)) {
    return 0;
  }
  const clamped = Math.max(0, Math.min(MAX_STAT_EFFORT, Math.floor(value)));
  return clamped;
};
